<template>
  <div id="thankyou_page">
    <header-section :title="'Thank you!'"></header-section>
    <loading-modal v-if="show_loading_api"></loading-modal>
    <div class="container">
      <div class="thankyou_element">
        <!-- <div class="thankyou_title">THANK YOU!</div> -->
        <div class="content">
          <i class="fa fa-check"></i>
        </div>
      </div> 
      <div class="thankyou_content">
        <div class="no_name">
          <p>Cảm ơn bạn đã đặt lịch hẹn với Cố vấn <strong>{{appointment.counselor_name}}</strong>. Chúng tôi sẽ gửi email xác nhận cho bạn trong vòng 24h tới.</p> 
          <!-- <div v-if="!isAuthenticated">
            <div class="next_step_question">Để được hỗ trợ nhanh chóng nhất cũng như nhận được những thông tin mới nhất từ MoraNow, bạn hãy đăng ký tài khoản với những thông tin dưới đây nhé.</div>
            <table class="table table-light info_appointment">
              <tr>
                <td>Tên</td>
                <td>{{appointment.customer_name}}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>{{appointment.customer_email}}</td>
              </tr>
              <tr>
                <td>Điện thoại</td>
                <td>{{appointment.customer_phone}}</td>
              </tr>
              <tr>
                <td>Địa chỉ</td>
                <td>{{appointment.customer_address}}</td>
              </tr>
              <tr>
                <td>LinkedIn</td>
                <td>{{appointment.customer_linked}}</td>
              </tr>
            </table>            
          </div> -->
          <div class="next_step">        
            <!-- <button v-if="!isAuthenticated" class="register_now btn btn-success" @click="register_now()">Đăng ký ngay</button> -->
            <a href="/" class="register_now btn btn-success">Trở về trang chủ</a>
          </div>          
        </div>        
      </div>      
    </div>   
  </div>
</template>
<script>
  import HeaderSection from './components/Common/HeaderSection.vue'
  import {mapState, mapGetters} from 'vuex'
  import LoadingModal from "./components/Modal/LoadingModal.vue";
  export default{
    components:{
      HeaderSection,
      LoadingModal
    },
    data: function(){
      return{
        // show_loadding_api: false
      }
    },
    computed:{
      ...mapState('vuex_booking_form',{
        appointment: state => state.appointment_info,        
      }),
      ...mapState('user',{
        show_loading_api: state => state.show_loading_api
      }),
      ...mapGetters( 'user', [
        'isAuthenticated'
      ]),
    },
    created: function(){
      this.$store.dispatch('vuex_booking_form/load_appointment_info', this.$route.query.a_id)
    },
    methods:{
      register_now: function(){
        this.$store.dispatch('user/sign_up_without_password', {email: this.appointment.customer_email, name: this.appointment.customer_name})
      }
    }
  };
</script>
<style lang="scss" scoped>
  @import "./components/HomePage/common";
  @import "./components/Responsive/query";
  #thankyou_page{
    .container{
      .thankyou_element{
        text-align: center;
        font-size: 100px;
        .thankyou_title{          
          font-weight: 900;
          @include for-mobile-only{
            font-size: 50px;
          }
        }
        .content{
          i{
            color: #24b663;
          }
        }
      }
      .thankyou_content{
        text-align: center;
        font-size: 20px;
        p{
          font-weight: unset;
          font-size: 20px;
        }
        .next_step_question{
          padding-bottom: 10px;
        }
        table.info_appointment{
          width: 550px;          
          margin: auto;
          border: 1px solid black;
          td{
            text-align: left;
            border: 1px solid black
          }
        }        
      }
      .next_step{
        padding-top: 10px;    
        font-size: 20px;
        font-weight: 700;        
        text-align: center;
        .register_now{
          margin-top: 10px;
        }
      }
    }
  }
  
</style>


// WEBPACK FOOTER //
// src/views/ThankYou.vue